export function axCoerceObject(x) {
    if (x == null) {
        return null;
    }
    return x;
}
